import React from 'react'
import { Container } from './styled'

interface Props {
  isSelected?: boolean
  onClick?: () => void
}

export const AddressSelector: React.FC<Props> = ({
  isSelected,
  onClick,
  children
}) => {
  return (
    <Container
      isSelected={isSelected}
      onClick={onClick}
    >
      <input type='radio' checked={isSelected} readOnly />
      {children}
    </Container>
  )
}
